import { shadow_meld } from "../../abilities/warlock/shadow_meld";
const COWL_HATS = [
  {
    slug: "cowl-black-37",
    name: "Cowl",
    description: "For scowling",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "blackColor",
        value: 5
      },
      {
        stat: "blackRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_black",
      frameIndex: 37
    },
    tags: ["daily-rotation"],
    grantedActions: { shadow_meld },
    shopCategory: "hat"
  },
  {
    slug: "cowl-blue-37",
    name: "Cowl",
    description: "For scowling",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "blueColor",
        value: 5
      },
      {
        stat: "blueRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_blue",
      frameIndex: 37
    },
    tags: ["daily-rotation"],
    grantedActions: { shadow_meld },
    shopCategory: "hat"
  },
  {
    slug: "cowl-green-37",
    name: "Cowl",
    description: "For scowling",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "greenColor",
        value: 5
      },
      {
        stat: "greenRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_green",
      frameIndex: 37
    },
    tags: ["daily-rotation"],
    grantedActions: { shadow_meld },
    shopCategory: "hat"
  },
  {
    slug: "cowl-orange-37",
    name: "Cowl",
    description: "For scowling",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "greenRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_orange",
      frameIndex: 37
    },
    tags: ["daily-rotation"],
    grantedActions: { shadow_meld },
    shopCategory: "hat"
  },
  {
    slug: "cowl-pink-37",
    name: "Cowl",
    description: "For scowling",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "goldRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_pink",
      frameIndex: 37
    },
    tags: ["daily-rotation"],
    grantedActions: { shadow_meld },
    shopCategory: "hat"
  },
  {
    slug: "cowl-purple-37",
    name: "Cowl",
    description: "For scowling",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "blueRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_purple",
      frameIndex: 37
    },
    tags: ["daily-rotation"],
    grantedActions: { shadow_meld },
    shopCategory: "hat"
  },
  {
    slug: "cowl-red-37",
    name: "Cowl",
    description: "For scowling",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "redRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_red",
      frameIndex: 37
    },
    tags: ["daily-rotation"],
    grantedActions: { shadow_meld },
    shopCategory: "hat"
  },
  {
    slug: "cowl-yellow-37",
    name: "Cowl",
    description: "For scowling",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "goldColor",
        value: 5
      },
      {
        stat: "goldRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_yellow",
      frameIndex: 37
    },
    tags: ["daily-rotation"],
    grantedActions: { shadow_meld },
    shopCategory: "hat"
  }
];
export {
  COWL_HATS
};
//# sourceMappingURL=data:application/json;base64,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
